import { render, staticRenderFns } from "./Staff03.vue?vue&type=template&id=57cbb6b3&"
import script from "./Staff03.vue?vue&type=script&lang=js&"
export * from "./Staff03.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports